// extracted by mini-css-extract-plugin
module.exports = {"wrap":"BlogPostList-module--wrap--15-uY","title":"BlogPostList-module--title--1YnjA","list":"BlogPostList-module--list--34-gx","link":"BlogPostList-module--link--2Vmq6"};